module.exports = __webpack_public_path__ + "media/images/column-43c17917c9668ceed80a3dfa3689b746.svg";